// extracted by mini-css-extract-plugin
export default {"basket":"Cart_basket__g0EUD","items":"Cart_items__k+-GU","itemsPrice":"Cart_itemsPrice__XsrsB"};